import { render, staticRenderFns } from "./Schlauchpflege.vue?vue&type=template&id=7fbcd09b&"
import script from "./Schlauchpflege.vue?vue&type=script&lang=js&"
export * from "./Schlauchpflege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports